import { createFileRoute, redirect } from '@tanstack/react-router';

import { scope3SearchSchema } from '@/features/ghg/pages/GhgScope3CalculationsPage';

export const Route = createFileRoute('/_authenticated/ghg/calculations/scope3')({
  validateSearch: scope3SearchSchema,
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/ghg/emissions', search: { scope: 3 }, replace: true });
  },
});
